import React from 'react'
import BaseFridgeData from '../index'
import TempPlot from './temp-plot'
import Temperatures from './temperatures'
import { DateTime } from './date-time';
// import OpenAiChat from './open-ai-chat'


const Fridge = () => {
    return (
        <div
            className="w-100 d-flex flex-row flex-wrap"
            style={{
                background: '#000000',
                color: '#FFFFFF',
                minHeight: '100vh',
            }}
        >
            <div className="w-50" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                <Temperatures />
                {/*<OpenAiChat />*/}
                <DateTime />
            </div>
            <div className="w-50" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                <BaseFridgeData />
            </div>
        </div>
    )
}

export default Fridge
